import { render, staticRenderFns } from "./Ended.vue?vue&type=template&id=384f2de2"
import script from "./Ended.vue?vue&type=script&lang=js"
export * from "./Ended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports